var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleBottledGas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.506,
    height: 49.506,
    viewBox: "0 0 49.506 49.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "all_elements_icons_48px_bottled_gas",
    "data-name": "all / elements / icons / 48px bottled gas",
    transform: "translate(0.753 0.753)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "none",
    stroke: "#e62a32",
    strokeMiterlimit: 10,
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3922",
    "data-name": "Group 3922",
    transform: "translate(-514.055 -240.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M532.726,255.48v-5.643m10.654,5.643v-5.643",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M543.38,274.28v4.041a.715.715,0,0,1-.711.715h-9.231a.716.716,0,0,1-.712-.715V274.28m-2.663-8.872a24.5,24.5,0,0,0,15.981.021",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M538.053,276.319a8.407,8.407,0,0,1-8.323-8.441V262.3a8.324,8.324,0,1,1,16.647,0v5.581a8.407,8.407,0,0,1-8.324,8.44Z",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    y1: 1.265,
    transform: "translate(538.053 252.14)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    x2: 15.315,
    transform: "translate(530.396 249.421)",
    fill: "none",
    stroke: "#e62a32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.506
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBottledGas);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };